import { render, staticRenderFns } from "./PlayerLevel.vue?vue&type=template&id=6faff416"
import script from "./PlayerLevel.vue?vue&type=script&lang=js"
export * from "./PlayerLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports